import React from "react"
import "../assets/css/projects.css"
import garyProj from "../assets/imgs/GSLLC.png"
import nhsn from "../assets/imgs/NHSN.png"
import eli from "../assets/imgs/eli.png"
import resume from "../assets/imgs/AlexandriaFuller-AppEngineerResume3.docx"
import { maxHeight } from "@mui/system";
import AOS from 'aos';
import 'aos/dist/aos.css';

const project1Url = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
  }

const Projects = () => {
    return (
            <div id="projects" className="project-container">
                <div className="projects">
                    <h3 className="projects-title">Recent Projects</h3>
                    <div className="project1">
                        <div className="project-img">
                            <img src={garyProj} alt="" className="projectImg" />
                        </div>
                        <div className="project-text">
                            <h2 className="projectTitle">Gary Schoeniger LLC</h2>
                            <p className="projectText">
                                Gary Schoeniger, founder of the Entrepreneurial 
                                Learning Initiative (ELI), Gary has been a leading 
                                advocate for entrepreneurial mindset education in 
                                classrooms, organizations, and communities. He is an 
                                internationally recognized leader in entrepreneurial 
                                mindset education and professional development. His 
                                work focuses on redefining traditional concepts of 
                                entrepreneurship, emphasizing the mindset and behaviors 
                                that optimize engagement and unlock human potential. 
                                Described as someone who teaches with both intellect 
                                and heart, Gary brings a deeply human-centered approach 
                                to his work, inspiring others to rethink what it means 
                                to be innovative and entrepreneurial.
                            </p>
                            <h2>Skills Used</h2>
                            <p className="skills">
                                WordPress Custom Theme, Hosting Management, 
                                Bootstrap, CSS, HTML, JS, Software Integration
                            </p>
                            <button onClick={()=> window.open("https://garyschoeniger.com/", "_blank")} 
                                class="visit">Visit GSLLC</button>
                        </div>
                    </div>
                    <div className="project2">
                        <div className="project-img">
                            <img src={nhsn} alt="" className="projectImg" />
                        </div>
                        <div className="project-text">
                            <h2 className="projectTitle">Center for Disease Control &
                            Prevention: NHSN</h2>
                            <p className="projectText">
                            CDC’s National Healthcare Safety Network is the nation’s 
                            most widely used healthcare-associated infection tracking 
                            system. NHSN provides facilities, states, regions, and the 
                            nation with data needed to identify problem areas, measure 
                            progress of prevention efforts, and ultimately eliminate 
                            healthcare-associated infections.
                            <br /><br />
                                I managed and added content for the NHSN website, such
                                as the Neonatal Component, FAQs, and Dialysis Component.
                            </p>
                            <h2>Skills Used</h2>
                            <p className="skills">
                                WordPress Development, Bootstrap, CSS, HTML, 
                                JS, Software Integration
                            </p>
                            <button onClick={()=> window.open("https://www.cdc.gov/nhsn/index.html", "_blank")} 
                                class="visit">Visit NHSN</button>
                        </div>
                    </div>
                    <div className="project3">
                        <div className="project-img">
                            <img src={eli} alt="" className="projectImg" />
                        </div>
                        <div className="project-text">
                            <h2 className="projectTitle">The Entrepreneurial Learning
                            Initiative</h2>
                            <p className="projectText">
                            As the world’s leading provider of entrepreneurial mindset training, 
                            professional development, courseware, and consulting services, we 
                            are dedicated to unlocking entrepreneurial potential in diverse 
                            learning and professional environments. Through our tailored programs, 
                            we empower students, educators, community leaders, and corporate 
                            professionals to foster innovation, resilience, and opportunity 
                            creation.
                            <br /><br />
                                I worked with ELI as their Technical Admin then their 
                                Director of IT. During my employment, I managed and added 
                                content for their website, integrated platforms such as HubSpot for form 
                                integration and Accredible for digital badge integration with Teachable & 
                                Moodle LMS, and managed their virtual platforms such as their LMS. 
                            </p>
                            <h2>Skills Used</h2>
                            <p className="skills">
                                WordPress Development, Custom Plugin Development, Software Integration,
                                System Administration, Hubspot, Google Analytics, Google Tag Manager
                            </p>
                            <button onClick={()=> window.open("https://elimindset.com/", "_blank")} 
                                class="visit">Visit ELI</button>
                        </div>
                    </div>
                    <div className="resumeSection">
                        <h2 className="resumeTitle">See more of my work & skills in detail</h2>
                        <button class="visit">
                            <a href={resume} download="AlexandriaFuller-Resume">Download My Resume</a>
                        </button>
                    </div>
                </div>

            </div>
    )
}

export default Projects